import { forEach } from 'lodash';

import CoreUtils from '../../common/utils/CoreUtils';

import ScheduleDataModel from '../../schedules/ScheduleDataModel';

import UniformDailyPackageRuleRenderer from './UniformDailyPackageRuleRenderer';

const scheduleDateField = 'scheduleDate';

export default class UniformDailyDataModel extends ScheduleDataModel {
  getDefaultSortCriteria() {
    return {
      fields: ['localDateMs', 'contractCode'],
      order: ['asc', 'asc']
    };
  }

  processFullServerUpdate(scheduleUpdateDto) {
    this.allowToggleUniformDaily = scheduleUpdateDto.allowToggleUniformDaily;

    super.processFullServerUpdate(scheduleUpdateDto);
  }

  processContracts(scheduleUpdateDto) {
    forEach(scheduleUpdateDto.contracts, contractDto => {
      var contract = {};
      Object.assign(contract, contractDto);
      
      this.registerContract(contract);
    });
  }

  updateScheduleUsage(schedule, updatedDataFields) {
    super.updateScheduleUsage(schedule, updatedDataFields);

    var energySumMWh = 0;
    var energySumH = 0;

    forEach(
      schedule.hourlyDataFields, dataField => {
        energySumMWh += schedule[dataField].averageValue;
        energySumH += schedule[dataField].averageDuration;
      }
    );

    if (energySumMWh !== schedule.energySumMWh) {
      schedule.energySumMWh = energySumMWh;
      updatedDataFields.push('energySumMWh');
    }

    if (energySumH !== schedule.energySumH) {
      schedule.energySumH = energySumH;
      updatedDataFields.push('energySumH');
    }
  }

  updateOverallStatus() {
    super.updateOverallStatus();

    this.hasValidationErrors = this.allSchedules.some(
      schedule => schedule.hasValidationErrors
    );

    if (CoreUtils.isDefinedAndNotNull(this.commandDataModel)) {
      this.commandDataModel.updateProperties({
        hasValidationErrors: this.hasValidationErrors
      });
    }
  }

  establishEditFieldTriggers(editFieldTriggers) {
    super.establishEditFieldTriggers(editFieldTriggers);

    editFieldTriggers.push({
      triggerDataField: ScheduleDataModel.anyElectableHourFields,
      triggerValue: ScheduleDataModel.anyValue,
      updateDataField: ScheduleDataModel.allElectableHourFields,
      updateValue: ScheduleDataModel.sameValue
    });
  }

  onFieldValuesEditing(schedule, dataFieldValues) {
    if (!super.onFieldValuesEditing(schedule, dataFieldValues))
      return false;

    return this.filterUpdatingElectableHourFields(
      schedule,
      dataFieldValues,
      this.indexedContracts[schedule.contractCode]
    );
  }

  onScheduleCreated(schedule) {
    super.onScheduleCreated(schedule);
  }

  onScheduleUpdated(schedule, isServerUpdate, isPeerUpdate, updatedDataFields, quickEntryHints) {
    super.onScheduleUpdated(schedule, isServerUpdate, isPeerUpdate, updatedDataFields, quickEntryHints);

    if (!isServerUpdate && !isPeerUpdate)
      this.enforceSchedulePackageValue(schedule, updatedDataFields, quickEntryHints);
  }

  onSchedulesInitialized(schedules) {
    super.onSchedulesInitialized(schedules);

    schedules.forEach(
      schedule => this.determinePackageRuleFlags(
        schedule,
        scheduleDateField,
        (packageRule, otherDates) => UniformDailyPackageRuleRenderer(
          new Date(schedule.scheduleDate),
          packageRule.canConfigureIndependently,
          otherDates,
          'elected',
          this.locale
        )
      )
    );
  }

  enforceSchedulePackageValue(schedule, updatedDataFields, quickEntryHints) {
    var dateKey = ScheduleDataModel.generateDateKey(schedule.scheduleDate);
    var packageRule = this.indexedPackageRules[schedule.contractCode][dateKey];

    if (CoreUtils.isUndefinedOrNull(packageRule))
      return;

    if (packageRule.canConfigureIndependently)
      return;

    var packageDataFields = [];
    updatedDataFields.forEach(updatedDataField => {
      if (schedule.hourlyDataFields.indexOf(updatedDataField) !== -1)
        packageDataFields.push(updatedDataField);
    })

    if (packageDataFields.length === 0)
      return;

    var scheduleUpdateSets = [];
    forEach(packageRule.packageDateKeys, packageDateKey => {
      var scheduleDateKey = ScheduleDataModel.generateScheduleDateKey(
        packageDateKey,
        schedule.contractCode
      );

      var packageSchedule = this.dateIndexedSchedules[scheduleDateKey];
      if (CoreUtils.isDefinedAndNotNull(packageSchedule) && packageSchedule.scheduleId !== schedule.scheduleId) {
        var values = {};
        packageDataFields.forEach(
          packageDataField => values[packageDataField] = schedule[packageDataField]
        );

        if (CoreUtils.getPropertyCount(values) > 0)
          scheduleUpdateSets.push({
            scheduleId: packageSchedule.scheduleId,
            values: values
          });
      }
    });

    if (scheduleUpdateSets.length > 0)
      this.updateSchedules(scheduleUpdateSets, false, true);
  }
}